var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "more"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/more"
  }, /*#__PURE__*/React.createElement("g", {
    id: "more_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.95833 7.91675C3.0875 7.91675 2.375 8.62925 2.375 9.50008C2.375 10.3709 3.0875 11.0834 3.95833 11.0834C4.82917 11.0834 5.54167 10.3709 5.54167 9.50008C5.54167 8.62925 4.82917 7.91675 3.95833 7.91675Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.0418 7.91675C14.171 7.91675 13.4585 8.62925 13.4585 9.50008C13.4585 10.3709 14.171 11.0834 15.0418 11.0834C15.9127 11.0834 16.6252 10.3709 16.6252 9.50008C16.6252 8.62925 15.9127 7.91675 15.0418 7.91675Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.49984 7.91675C8.629 7.91675 7.9165 8.62925 7.9165 9.50008C7.9165 10.3709 8.629 11.0834 9.49984 11.0834C10.3707 11.0834 11.0832 10.3709 11.0832 9.50008C11.0832 8.62925 10.3707 7.91675 9.49984 7.91675Z",
    fill: "#1A1A1A"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.33f23d49c49fdaaf4f8495d01f734044.svg";
export { ForwardRef as ReactComponent };